import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { Icon } from '@calendly/ui/components/icon';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { Group, Item } from '@calendly/ui/components/menu';
import { OptionUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Layout } from 'components/layout';
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction';
import { pushHrefMergingSearch, useSchedulesRoutes } from '../../schedules_routes_context';
import { StyledDropdownMenu } from '../styles';
import { CreateSchedulePopup } from './create_schedule_popup';
const controlButtonCss = "cdcrter";
const ControlButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(controlButtonCss, props.className)} />);
const getScheduleOptions = (sortedSchedules, schedulesRoutes, defaultScheduleId) => sortedSchedules.map(schedule => {
  const isDefault = schedule.id === defaultScheduleId;
  return {
    scheduleId: schedule.id,
    value: schedulesRoutes.hrefForSchedule(schedule.id, defaultScheduleId),
    name: isDefault ? `${schedule.name} ${I18n.t('publisher.event_type_editor.sections.available_hours.default_indicator')}` : schedule.name
  };
});
export const ScheduleSelect = ({
  sortedSchedules,
  disabled,
  selectedScheduleId,
  defaultScheduleId
}) => {
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const history = useHistory();
  const schedulesRoutes = useSchedulesRoutes();
  const scheduleOptions = useMemo(() => getScheduleOptions(sortedSchedules, schedulesRoutes, defaultScheduleId), [sortedSchedules, schedulesRoutes, defaultScheduleId]);
  const isCreateSchedulePopupOpen = history.location.search.includes('new=true');
  const trackViewScheduleMenu = useTrackAvailabilityInteraction({
    action: 'view_schedule_menu'
  });
  const trackClickCreateSchedule = useTrackAvailabilityInteraction({
    action: 'click_create_schedule'
  });
  const handleClick = () => {
    if (!isExpanded) trackViewScheduleMenu();
    toggle();
  };
  const handleCreateSchedule = () => {
    if (!isCreateSchedulePopupOpen) trackClickCreateSchedule();
    pushHrefMergingSearch(history, {
      new: 'true'
    });
  };
  return <Layout relative>
      <ControlButton aria-labelledby="rule-select-label" disabled={disabled} onClick={handleClick}>
        {scheduleOptions.find(({
        scheduleId
      }) => scheduleId === selectedScheduleId)?.name}
        <Icon size="large" name={isExpanded ? 'angle-up' : 'angle-down'} />
      </ControlButton>
      <Dropdown>
        <StyledDropdownMenu>
          <Group>
            {scheduleOptions.map(({
            value,
            name,
            scheduleId
          }) => <OptionUI key={value} value={value} selected={scheduleId === selectedScheduleId} onClick={() => {
            history.push(value);
            toggle();
          }}>
                <BodyText size="medium">{name}</BodyText>
              </OptionUI>)}
          </Group>
          <Group>
            <Item onClick={handleCreateSchedule}>
              <AddMiniIcon />
              {I18n.t('publisher.availability.schedules.create_schedule')}
            </Item>
          </Group>
        </StyledDropdownMenu>
      </Dropdown>
      {isCreateSchedulePopupOpen && <CreateSchedulePopup />}
    </Layout>;
};

require("./schedule_select.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./schedule_select.js");